import React from "react";
import {ReactComponent as AddIcon} from "../../../../assets/icons/add.svg";
import {ReactComponent as AddInvertedRoundIcon} from "../../../../assets/icons/add-inverted-round.svg";
import {ReactComponent as AngleUpIcon} from "../../../../assets/icons/angleUp.svg";
import {ReactComponent as AnnouncementIcon} from "../../../../assets/icons/announcement.svg";
import {ReactComponent as BlockIcon} from "../../../../assets/icons/block.svg";
import {ReactComponent as CalendarIcon} from "../../../../assets/icons/calendar.svg";
import {ReactComponent as CatalogueIcon} from "../../../../assets/icons/catalogue.svg";
import {ReactComponent as DeleteIcon} from "../../../../assets/icons/delete.svg";
import {ReactComponent as DescriptionIcon} from "../../../../assets/icons/description.svg";
import {ReactComponent as DetachedOccurrenceIcon} from "../../../../assets/icons/detached-occurrence.svg";
import {ReactComponent as DownIcon} from "../../../../assets/icons/down.svg";
import {ReactComponent as DropdownIcon} from "../../../../assets/icons/dropdown.svg";
import {ReactComponent as EditIcon} from "../../../../assets/icons/edit.svg";
import {ReactComponent as EmailIcon} from "../../../../assets/icons/email.svg";
import {ReactComponent as ErrorIcon} from "../../../../assets/icons/error.svg";
import {ReactComponent as ExitIcon} from "../../../../assets/icons/exit.svg";
import {ReactComponent as ExpiredIcon} from "../../../../assets/icons/expired.svg";
import {ReactComponent as ExportIcon} from "../../../../assets/icons/export.svg";
import {ReactComponent as FavouriteIcon} from "../../../../assets/icons/favourite.svg";
import {ReactComponent as FeaturedIcon} from "../../../../assets/icons/featured.svg";
import {ReactComponent as GeneralIcon} from "../../../../assets/icons/general.svg";
import {ReactComponent as GuestIcon} from "../../../../assets/icons/guest.svg";
import {ReactComponent as HelpIcon} from "../../../../assets/icons/help.svg";
import {ReactComponent as HideIcon} from "../../../../assets/icons/hide.svg";
import {ReactComponent as HomeIcon} from "../../../../assets/icons/home.svg";
import {ReactComponent as ImageIcon} from "../../../../assets/icons/image.svg";
import {ReactComponent as InfoIcon} from "../../../../assets/icons/info.svg";
import {ReactComponent as LeftArrowIcon} from "../../../../assets/icons/left-arrow.svg";
import {ReactComponent as LeftChevronIcon} from "../../../../assets/icons/left-chevron.svg";
import {ReactComponent as LoadingIcon} from "../../../../assets/icons/loading.svg";
import {ReactComponent as LocationIcon} from "../../../../assets/icons/location.svg";
import {ReactComponent as LockIcon} from "../../../../assets/icons/lock.svg";
import {ReactComponent as LogoutIcon} from "../../../../assets/icons/logout.svg";
import {ReactComponent as MealIcon} from "../../../../assets/icons/meal.svg";
import {ReactComponent as MenuIcon} from "../../../../assets/icons/menu.svg";
import {ReactComponent as MetricsIcon} from "../../../../assets/icons/metrics.svg";
import {ReactComponent as MoreIcon} from "../../../../assets/icons/more.svg";
import {ReactComponent as NoSearchResultsIcon} from "../../../../assets/icons/no-search-results.svg";
import {ReactComponent as NotificationIcon} from "../../../../assets/icons/notification.svg";
import {ReactComponent as PaidIcon} from "../../../../assets/icons/paid.svg";
import {ReactComponent as PasswordIcon} from "../../../../assets/icons/password.svg";
import {ReactComponent as PhoneIcon} from "../../../../assets/icons/phone.svg";
import {ReactComponent as PublishedIcon} from "../../../../assets/icons/published.svg";
import {ReactComponent as RecentIcon} from "../../../../assets/icons/recent.svg";
import {ReactComponent as ReplaceIcon} from "../../../../assets/icons/replace.svg";
import {ReactComponent as ResidentsIcon} from "../../../../assets/icons/residents.svg";
import {ReactComponent as RightArrowIcon} from "../../../../assets/icons/right-arrow.svg";
import {ReactComponent as RightChevronIcon} from "../../../../assets/icons/right-chevron.svg";
import {ReactComponent as RotateIcon} from "../../../../assets/icons/rotate.svg";
import {ReactComponent as SearchIcon} from "../../../../assets/icons/search.svg";
import {ReactComponent as SendIcon} from "../../../../assets/icons/send.svg";
import {ReactComponent as SeriesIcon} from "../../../../assets/icons/series.svg";
import {ReactComponent as ShowIcon} from "../../../../assets/icons/show.svg";
import {ReactComponent as SpecialDay} from "../../../../assets/icons/special-day.svg";
import {ReactComponent as StatusIcon} from "../../../../assets/icons/status.svg";
import {ReactComponent as SuccessIcon} from "../../../../assets/icons/success.svg";
import {ReactComponent as SuccessTickIcon} from "../../../../assets/icons/success-tick.svg";
import {ReactComponent as ToggleBothIcon} from "../../../../assets/icons/toggle-both.svg";
import {ReactComponent as ToggleDownIcon} from "../../../../assets/icons/toggle-down.svg";
import {ReactComponent as ToggleUpIcon} from "../../../../assets/icons/toggle-up.svg";
import {ReactComponent as UndoIcon} from "../../../../assets/icons/undo.svg";
import {ReactComponent as UpIcon} from "../../../../assets/icons/up.svg";
import {ReactComponent as UpdatesIcon} from "../../../../assets/icons/updates.svg";
import {ReactComponent as VillageIcon} from "../../../../assets/icons/village.svg";
import {ReactComponent as VirtualIcon} from "../../../../assets/icons/virtual.svg";
import {ReactComponent as ZoomInIcon} from "../../../../assets/icons/zoom-in.svg";
import {ReactComponent as ZoomOutIcon} from "../../../../assets/icons/zoom-out.svg";
import {ReactComponent as DollarTag} from "../../../../assets/icons/dollar-tag.svg";
import {IconSource} from "../../../../shared/enums/iconSource";
import "./icon.sass";

// For help adding new icons, or editing existing icons, see the readme file inside this folder.

interface IconProps {
  source: IconSource;
  onClick?: () => void;
  id?: string;
}

const iconMap = new Map<IconSource, JSX.Element>([
  [IconSource.add, <AddIcon />],
  [IconSource.addInvertedRound, <AddInvertedRoundIcon />],
  [IconSource.angleUp, <AngleUpIcon />],
  [IconSource.announcement, <AnnouncementIcon />],
  [IconSource.block, <BlockIcon />],
  [IconSource.calendar, <CalendarIcon />],
  [IconSource.catalogue, <CatalogueIcon />],
  [IconSource.delete, <DeleteIcon />],
  [IconSource.description, <DescriptionIcon />],
  [IconSource.detachedOccurrence, <DetachedOccurrenceIcon />],
  [IconSource.down, <DownIcon />],
  [IconSource.dropdown, <DropdownIcon />],
  [IconSource.edit, <EditIcon />],
  [IconSource.email, <EmailIcon />],
  [IconSource.error, <ErrorIcon />],
  [IconSource.exit, <ExitIcon />],
  [IconSource.expired, <ExpiredIcon />],
  [IconSource.export, <ExportIcon />],
  [IconSource.favourite, <FavouriteIcon />],
  [IconSource.featured, <FeaturedIcon />],
  [IconSource.general, <GeneralIcon />],
  [IconSource.guest, <GuestIcon />],
  [IconSource.help, <HelpIcon />],
  [IconSource.hide, <HideIcon />],
  [IconSource.home, <HomeIcon />],
  [IconSource.image, <ImageIcon />],
  [IconSource.info, <InfoIcon />],
  [IconSource.leftArrow, <LeftArrowIcon />],
  [IconSource.leftChevron, <LeftChevronIcon />],
  [IconSource.loading, <LoadingIcon />],
  [IconSource.location, <LocationIcon />],
  [IconSource.lock, <LockIcon />],
  [IconSource.logout, <LogoutIcon />],
  [IconSource.meal, <MealIcon />],
  [IconSource.menu, <MenuIcon />],
  [IconSource.metrics, <MetricsIcon />],
  [IconSource.more, <MoreIcon />],
  [IconSource.noSearchResults, <NoSearchResultsIcon />],
  [IconSource.notification, <NotificationIcon />],
  [IconSource.paid, <PaidIcon />],
  [IconSource.password, <PasswordIcon />],
  [IconSource.phone, <PhoneIcon />],
  [IconSource.published, <PublishedIcon />],
  [IconSource.recent, <RecentIcon />],
  [IconSource.replace, <ReplaceIcon />],
  [IconSource.residents, <ResidentsIcon />],
  [IconSource.rightArrow, <RightArrowIcon />],
  [IconSource.rightChevron, <RightChevronIcon />],
  [IconSource.rotate, <RotateIcon />],
  [IconSource.search, <SearchIcon />],
  [IconSource.send, <SendIcon />],
  [IconSource.series, <SeriesIcon />],
  [IconSource.show, <ShowIcon />],
  [IconSource.specialDay, <SpecialDay />],
  [IconSource.status, <StatusIcon />],
  [IconSource.success, <SuccessIcon />],
  [IconSource.successTick, <SuccessTickIcon />],
  [IconSource.toggleBoth, <ToggleBothIcon />],
  [IconSource.toggleDown, <ToggleDownIcon />],
  [IconSource.toggleUp, <ToggleUpIcon />],
  [IconSource.undo, <UndoIcon />],
  [IconSource.up, <UpIcon />],
  [IconSource.updates, <UpdatesIcon />],
  [IconSource.village, <VillageIcon />],
  [IconSource.virtual, <VirtualIcon />],
  [IconSource.zoomIn, <ZoomInIcon />],
  [IconSource.zoomOut, <ZoomOutIcon />],
  [IconSource.dollarTag, <DollarTag />]
]);

const Icon: React.FunctionComponent<IconProps> = ({id, source, onClick}) => {
  let svg = iconMap.get(source) ?? <svg />;

  // Embed the correct props onto the svg element
  svg = React.cloneElement(svg, {
    id: id,
    "data-icon": source,
    onClick
  });

  return <>{svg}</>;
};

export default Icon;
